module.exports = __webpack_public_path__ + "img/logo02.924e2f2a.png";